











































































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { RootGettersReturns } from '../../../store/types';
import { ElementActionsKeys, ElementActionsPayload } from '../../../store/types/element';
import CircleIcon from '../../shared/CircleIcon.vue';
import { StageActionsKeys, StageActionsPayload } from '../../../store/types/stageState';

type dataType = {
  color: string;
  thickness: string;
};

@Component({
  components: {
    CircleIcon,
  },
})
export default class DrawingToolbar extends Vue {
  @Getter selectedElement!: RootGettersReturns['selectedElement'];
  @Getter focusState!: RootGettersReturns['focusState'];
  @Getter isGuest!: RootGettersReturns['isGuest'];
  @Getter sharedBoard!: RootGettersReturns['sharedBoard'];

  @Action(ElementActionsKeys.UPDATE_ELEMENT) updateElement!: (payload: ElementActionsPayload['UPDATE_ELEMENT']) => void;
  @Action(StageActionsKeys.SET_FOCUS) focus!: (payload: StageActionsPayload['SET_FOCUS']) => void;

  drawingColors = [
    '#212121',
    '#9E9E9E',
    '#E0E0E0',
    '#F44336',
    '#FB8C00',
    '#FFC400',
    '#00796B',
    '#4CAF50',
    '#CEE742',
    '#9134A2',
    '#0D47A1',
    '#2196F3',
  ];
  drawingThickness = ['2', '3', '5', '7', '9', '11'];

  activeHelper: 'color' | 'thickness' | null = null;

  mounted() {
    this.activeHelper = null;
  }

  setActiveHelper(type: 'color' | 'thickness') {
    this.activeHelper = type;
  }

  get elementData(): dataType {
    if (!this.selectedElement)
      return {
        thickness: '1',
        color: 'black',
      };
    return this.selectedElement.data as dataType;
  }

  activateDrawingColor(color: string) {
    if (!this.selectedElement) return;
    this.updateElement({
      ...this.selectedElement,
      data: {
        ...this.selectedElement.data,
        color,
      },
    });
  }

  activateDrawingThickness(thickness: string) {
    if (!this.selectedElement) return;
    this.updateElement({
      ...this.selectedElement,
      data: {
        ...this.selectedElement.data,
        thickness,
      },
    });
  }

  deleteElement() {
    if (!this.selectedElement) return;
    this.updateElement({
      ...this.selectedElement,
      deleted: true,
    });
  }

  focusElement() {
    if (!this.selectedElement) return;
    this.focus({ board_element: this.focusState ? null : this.selectedElement, withPrevState: true });
  }
}
